import { render, staticRenderFns } from "./EmbryoTransplantationTable.vue?vue&type=template&id=f7c52ff2&"
import script from "./EmbryoTransplantationTable.vue?vue&type=script&lang=js&"
export * from "./EmbryoTransplantationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports